import { getCurrentSystemKey } from "../../config/domain";

export const PAGE_SIZE = 10;
// System key of the current host's domain (e.g. 'MSA' / 'ATLAS'), resolved from
// the hostname. Portal host falls back to the default system key. Replaces the
// previous hardcoded "MSA" so a single build serves multiple system domains.
export const SYSTEM = getCurrentSystemKey();
export const ALL_OPTION = { label: "All", value: "All" } as const;

export const ENTITY_TYPE_OPTIONS = [
  { label: "Amazon User", value: "user" },
  // { label: "Team", value: "team" },
  { label: "Vendor", value: "vendor" },
];

export const ENTITY_TYPE_LABEL: Record<string, string> = {
  user: "Amazon User",
  team: "Team",
  vendor: "Vendor",
};
